import { api } from "../../app/api";
import { Options } from "../../common/types/requestOptions";
import { LanguageCode } from "../localized/localizedApi";

export type LanguageSkill = {
  id: string;
  name: string;
  code: string;
};

export interface LanguageSkillFilters {
  language: LanguageCode;
}

export const languageSkillsQuery = async (
  filters: LanguageSkillFilters,
  { requestId }: Options = {},
) => {
  const res = await api.get<LanguageSkill[]>(
    "/projections/qry/languageSkills",
    {
      requestId,
      auth: true,
      queryParams: { ...filters },
    },
  );
  return res.data;
};
